/* DEV NOTE: This file is intended to act as an index for all
 * available endpoint queries. Individual query export functions
 * should be placed in separate files based on the entity they are
 * associated with, and referenced here for export.
 */

import {
  fetchGraphQL
} from '../Connections/';

import {
  getFieldEnumValuesQueryString
} from './util';


export function queryGetFieldAllowedValues(fields) {
  let fieldEnumValuesQueryStrings = [];
  for (let field in fields) {
    fieldEnumValuesQueryStrings.push(getFieldEnumValuesQueryString(field, fields[field].enumName));
  }

  const query = `query {
    ${fieldEnumValuesQueryStrings.join(',\n')}
  }`;

  return fetchGraphQL({
    query
  });
}

export function queryGetGarageInfo(facility_id) {
  return `query listRates{
    listRates(facility_id: ${facility_id}) {
      id,
      facility_id,
      name,
      description,
      active,
      decline_recurring,
      display,
      display_price,
      pass_type,
      access_hours,
      location,
      require_car_info,
      first_month_proration,
      tax_exempt,
      terms_and_conditions,
      terms_and_conditions_summary,
      next_steps,
      created_at,
      updated_at,
      current_monthly_fee { id },
      fees {
        id,
        type,
        price,
        start_date,
        payment_timing,
        tax_1,
        tax_2,
        tax_3,
        tax_4,
      },
      facility {
        id, 
        facility_name,
        address,
        tenants,
        timezone,
      },
      access_devices {
        type,
        fee {
          id,
          type,
          price,
          start_date,
          payment_timing,
          tax_1,
          tax_2,
          tax_3,
          tax_4
        }
      }
    }
  }`;
};


export {
  queryListRates,
  queryGetRate,
  queryCreateRate,
  queryUpdateRate
} from './Rate';


export {
  queryListBillingProfiles,
  queryGetBillingProfile,
  queryCreateBillingProfile,
  queryUpdateBillingProfile
} from './BillingProfile';


export {
  queryGetPayors,
  queryGetPayor,
  queryUpdatePayor,
  queryCreatePayor,
  queryGetPayorReport,
  queryCreateCustomerNote,
  queryUpdatePayorCognitoSub,
  queryGetCognitoSub,
  queryUpdateSubscription
} from './Payor';


export {
  queryListParkers,
  queryCreateParker,
  queryUpdateParker,
  queryGetParkerReport,
  querySendBarcodeEmail,
} from './Parker';


export {
  queryListSubscriptions,
  queryGetSubscription,
  queryCreateSubscription,
  queryPerformBulkParkerAction,
  queryMyProfile,
  querymakePayment,
  queryGetCreditCardFeePrice,
  queryDeleteCreditCards,
} from './Subscription';


export {
  queryListInvoices,
  queryGetInvoice,
  queryCreateInvoice,
  queryUpdateInvoice,
  queryGetInvoiceReport,
  queryGetInvoicePDF,
  queryResendInvoiceEmail
} from './Invoice';


export {
  queryAdminApplyPayment,
  queryRefundPayment,
  queryReversePayment,
} from './Payment';


export {
  queryListFacilities,
  queryGetFacility,
  queryGetFacilitySettings,
  queryCreateFacilitySettings,
  queryUpdateFacilitySettings,
  queryGetBalanceReport,
  queryGetBalanceSummaryReport,
  queryGetSignUpTerminationReport,
  queryGetReport,
  queryGetPaymentApplicationMonths,
  queryGetBalanceReportPdf,
  queryGetBalanceSummaryReportPdf,
  queryGetFacilityPaymentTypes,
  mutateUpdateFacilityPaymentTypes,
} from './Facility';

export {
  queryListCredits,
  queryGetCredit,
  queryCreateCredit,
  queryReverseCredit,
  queryIncreaseCredit,
  queryWriteOffCredit,
  queryGetCreditBalances,
  queryGetCreditsForInvoicePayment,
} from './Credit';

export {
  queryListTransactions,
  querySubscriptionHistoryReport
} from './Transaction';
